/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Getting_Started__Answer_4Inputs */

const en_help_center__getting_started__answer_4 = /** @type {(inputs: Help_Center__Getting_Started__Answer_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes! BidBattles is a fully licensed auction platform operating in the Netherlands and Belgium. All products are authentic, new, and come with manufacturer warranties. We work directly with authorized dealers and suppliers. Every winner receives their product as advertised, and we have a proven track record of satisfied customers.`)
};

/**
* | output |
* | --- |
* | "Yes! BidBattles is a fully licensed auction platform operating in the Netherlands and Belgium. All products are authentic, new, and come with manufacturer wa..." |
*
* @param {Help_Center__Getting_Started__Answer_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__getting_started__answer_4 = /** @type {((inputs?: Help_Center__Getting_Started__Answer_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Getting_Started__Answer_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__getting_started__answer_4(inputs)
});